import React from "react";
import Hero from "../components/Hero";
import ResidentialProperties from "../components/ResidentialProperties";
// import CommercialProperties from "../components/CommercialProperties";
// import SplitBackgroundSection from "../components/Collaboration";
import Assurance from "../components/Assurance";
import CustomerReviews from "../components/CustomerReviews";
import Footer from "../components/Footer";
// import AboutUs from "../components/AboutUs";
import BlogSection from "../components/Blogs";
import ChatBot from "../components/ChatBot";
import CommitmentSection from "../components/Commitment";
import Enquiry from "../components/Enquiry";
import WhatsAppButton from "../components/Whatsapp";
// import PartnerSection from "../components/Partner";

const Home = () => {
  return (
    <div>
      <Hero />
      <CommitmentSection />
      <ResidentialProperties />
      {/* <CommercialProperties /> */}
      {/* <AboutUs /> */}
      {/* <SplitBackgroundSection /> */}
      <Assurance />
      {/* <PartnerSection /> */}
      <BlogSection />
      <CustomerReviews />
      <ChatBot />
      <Enquiry />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Home;
